export default __webpack_public_path__ + "static/media/QuarterPipe_Corner_02.256.4af8408e.png";